import React, { useContext } from 'react'
import { OffreModel } from './types/OffreModel'
import { WHITE } from '../../theme'
import { ResponsiveContext } from '../../utils/context/ResponsiveContext'
import Entete from './components/Entete'
import Photos from './components/Photos'
import Caracteristiques from './components/Caracteristiques'
import Description from './components/Description'
import Atouts from './components/Atouts'
import PointsInterets from '../residence/components/PointsInterets'
import Residence from './components/Residence'
import OffresLiees from './components/OffresLiees'
import { Sticky, StickyContainer } from 'react-sticky'
import InformationsTarifaires from './components/InformationsTarifaires'
import ConditionsTarifaires from './components/ConditionsTarifaires'
import { Element } from 'react-scroll'
import { menuAncresEnum } from './enums/menuAncresEnum'
import ChauffageEtDiagnostics from './components/ChauffageEtDiagnostics'
import { isEmpty } from 'lodash'
import styles from '../../styles'
import BlocLiens from '../landingPageSEO/components/BlocLiens'
import { makeStyles } from 'tss-react/mui'
import { AppBar, Grid } from '@mui/material'
import { lotTypesEnum } from '../../enums/lot/lotTypesEnum'

const useStyles = makeStyles<{ isMenuLargeScreen: boolean }>()((theme, { isMenuLargeScreen }) => ({
	...styles(theme),
	offreContainer: {
		background: WHITE
	},
	filArianeContainer: {
		padding: '12px 60px 11px'
	},
	retourContainer: {
		padding: '27px 30px 37px'
	},
	contenusContainer: {
		marginLeft: isMenuLargeScreen ? 60 : 0,
		marginRight: isMenuLargeScreen ? 60 : 0,
		marginTop: isMenuLargeScreen ? 59 : 45,
		marginBottom: isMenuLargeScreen ? 162 : 55
	},
	blocGaucheConteneur: {
		marginLeft: isMenuLargeScreen ? 0 : 30,
		marginRight: isMenuLargeScreen ? 0 : 30
	},
	blocGris: {
		backgroundColor: theme.palette.blue['5'],
		padding: isMenuLargeScreen ? '0 65px' : '0 30px',
		zIndex: isMenuLargeScreen ? 1 : 2,
		borderRadius: isMenuLargeScreen ? 0 : '0 0 30px 30px'
	},
	sansOffresSimilaires: {
		paddingTop: isMenuLargeScreen ? 50 : 35,
		borderRadius: isMenuLargeScreen ? 30 : '0 0 30px 30px',
		zIndex: 2,
		marginTop: isMenuLargeScreen ? -30 : 0
	},
	stickyContainerStyle: {
		width: '100%'
	},
	appBarStyle: {
		zIndex: 2,
		position: 'fixed',
		bottom: 0,
		top: 'unset'
	}
}))

interface AcceptingProps {
	offre: OffreModel
}

export type OffreProps = AcceptingProps

const Offre: React.FC<OffreProps> = ({ offre }) => {
	// N.B ici on utilise isMenuLargeScreen au lieu de isLargeScreen car avec la partie gauche pour la sélection, il faut passer en affichage mobile plus tôt
	const { isMenuLargeScreen } = useContext(ResponsiveContext)
	const { classes, cx } = useStyles({ isMenuLargeScreen })

	return (
		<StickyContainer className={classes.stickyContainerStyle}>
			<Grid container item xs={12} className={classes.offreContainer}>
				{/*	Bloc d'Entête*/}
				<Entete offre={offre} />

				{/*	Bloc Photos */}
				{offre.photos.length > 0 && <Photos offre={offre} />}

				{/* Bloc contenant la séparation gauche et droite des contenus */}
				<Grid container item xs={12} className={classes.contenusContainer} spacing={isMenuLargeScreen ? 4 : 0}>
					{/* Bloc de gauche */}
					<Grid container item xs={12} md={8} alignItems="flex-start" className={classes.blocGaucheConteneur}>
						<Element name={menuAncresEnum.DESCRIPTIF} style={{ width: '100%' }}>
							{/* Bloc de description */}
							<Description offre={offre} />

							{/* Bloc des atouts */}
							{offre.type === lotTypesEnum.apartment && <Atouts offre={offre} />}

							{/* Bloc du chauffage et des diagnostics de gaz à effet de serre */}
							{offre.type === lotTypesEnum.apartment && <ChauffageEtDiagnostics offre={offre} />}
						</Element>

						{/* Bloc sur les conditions tarifaires */}
						<ConditionsTarifaires offre={offre} />
					</Grid>

					{/* Bloc de droite, contenant uniquement les caractéristiques */}
					{isMenuLargeScreen && (
						<Grid container item xs={12} md={4}>
							<Caracteristiques offre={offre} />
						</Grid>
					)}
				</Grid>

				{/* Bloc contenant la carte Alentoor */}
				<Element name={menuAncresEnum.QUARTIER} style={{ width: '100%' }}>
					<PointsInterets
						alentoorApiKey={offre.alentoorApiKey}
						longitude={offre.residence.longitude}
						latitude={offre.residence.latitude}
					/>
				</Element>

				{/* Bloc Résidence */}
				{offre.residence.residencePubliee && <Residence offre={offre} />}

				{/* Bloc des Offres liées */}
				{offre.offresSimilaires.length > 0 && <OffresLiees offre={offre} />}

				{/* Bloc liens */}
				{!isEmpty(offre.blocLiens.liens) && (
					<Grid container item xs={12} className={classes.blocGris}>
						<BlocLiens blocLiens={offre.blocLiens} />
					</Grid>
				)}
			</Grid>

			{!isMenuLargeScreen && (
				<Sticky
					relative
					bottomOffset={-window.innerHeight}
				>
					{({ style, distanceFromBottom }) => (
						<AppBar
							elevation={0}
							className={cx('informationsTarifairesOffre', classes.appBarStyle)}
							style={{ ...style, display: style.display, visibility: distanceFromBottom < 0 ? 'hidden' : 'visible' }}
						>
							<InformationsTarifaires offre={offre} />
						</AppBar>
					)}
				</Sticky>
			)}
		</StickyContainer>
	)
}

export default Offre